var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-offcanvas-content",attrs:{"id":"app"}},[_c('AppHeader',{on:{"changeLanguage":_vm.changeLanguage}}),_vm._v(" "),_c('AppBody'),_vm._v(" "),_c('AppFooter'),_vm._v(" "),_c('AppOffcanvas',{on:{"changeLanguage":_vm.changeLanguage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ce4629a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = null
// module chunks = 